import { Chip, Icon } from "@legal-500/legal500-design-system";
import styles from "./DataMartCard.module.css";

export type DataMart = {
  id: string;
  name: string;
  description: string;
  tableCount: number;
};

export type DataMartCardProps = {
  dataMart: DataMart;
  onClick?: (dataMart: DataMart) => void;
};

export function DataMartCard({ dataMart, onClick }: DataMartCardProps) {
  const handleClick = () => {
    onClick?.(dataMart);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onClick?.(dataMart);
    }
  };

  return (
    <div
      className={styles.card}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      aria-label={`Data mart ${dataMart.name}`}
    >
      <div className={styles.header}>
        <div className={styles.iconWrapper}>
          <Icon icon="folder" size="default" />
        </div>
        <h3 className={styles.name}>{dataMart.name}</h3>
      </div>

      <div className={styles.content}>
        <p className={styles.description}>{dataMart.description}</p>
      </div>

      <div className={styles.footer}>
        <Chip size="small" variant="filled" className={styles.typeBadge}>
          Data Mart
        </Chip>
        <span className={styles.tableCount}>{dataMart.tableCount} tables</span>
      </div>
    </div>
  );
}
